import { createStore } from '@nile/mangifera/src/StoreManager/store/createStore';

interface OnboardingData {
  isActive: boolean;
  currentStep: number;
  currentFeature: string | null;
  moduleCompleted: Record<string, boolean>;
}

const onboardingStoreConfig = {
  id: 'aiOnboarding',
  initialState: {
    data: {
      isActive: false,
      currentStep: 0,
      currentFeature: null,
      moduleCompleted: {}
    }
  },
  methods: (set, get) => ({
    startOnboarding: (module: string) => {
      const data = get().data;
      set({
        data: {
          ...data,
          isActive: true,
          currentStep: 0,
          currentFeature: module
        }
      });
    },

    nextStep: () => {
      const data = get().data;
      set({
        data: {
          ...data,
          currentStep: data.currentStep + 1
        }
      });
    },

    prevStep: () => {
      const data = get().data;
      set({
        data: {
          ...data,
          currentStep: Math.max(0, data.currentStep - 1)
        }
      });
    },

    completeOnboarding: () => {
      const data = get().data;
      if (data.currentFeature) {
        set({
          data: {
            ...data,
            isActive: false,
            currentStep: 0,
            currentFeature: null,
            moduleCompleted: {
              ...data.moduleCompleted,
              [data.currentFeature]: true
            }
          }
        });
      }
    },

    skipOnboarding: () => {
      const data = get().data;
      set({
        data: {
          ...data,
          isActive: false,
          currentStep: 0,
          currentFeature: null
        }
      });
    },

    resetOnBoarding: () => {
      set({
        data: {
          isActive: false,
          currentStep: 0,
          currentFeature: null,
          moduleCompleted: {}
        }
      });
    },

    getModuleProgress: (module: string) => {
      // This would need to be implemented based on your onboarding config
      return { completed: 0, total: 1 };
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true
  }
};

export const useOnboarding = createStore(onboardingStoreConfig);
